// Menu: Large Bar
// 

JLM.MD.MenuBarLarge = function( container ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let link_search, link_shortlist, tally_shortlist;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		let link_brand, sub_labels, label_selected, features, link_contact;
		
		// Fetch references
		link_brand = $('a.branding', container);
		sub_labels = $('.group > ul .label', container);
		features = $('.features', features);
		link_contact = $('li[data-action="contact"]', features);
		link_search = $('li[data-action="search"]', features);
		link_shortlist = $('li[data-action="shortlist"]', features);
			tally_shortlist = $('.label span', link_shortlist);
		
		// Events
		sub_labels.on('click', function() {
			if ( label_selected && $(this)[0] === label_selected[0] ) {
				$(this).parent().removeClass('selected');
				label_selected = null;
			} else {
				$('.group > ul > li.selected', container).removeClass('selected');
				$(this).parent().toggleClass('selected');
				label_selected = $(this);
			}
		});
		link_contact.on('click', navigateToContact);
		link_search.on('click', toggleSearch);
		link_shortlist.on('click', toggleShortlist);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Bubbling Events
	// 
	function navigateToContact() {
		INSTANCE.dispatchEvent('navigate_contact');
	}
	function toggleSearch() {
		INSTANCE.dispatchEvent('toggle_search');
	}
	function toggleShortlist() {
		INSTANCE.dispatchEvent('toggle_shortlist');
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Update selected states
	// 
	INSTANCE.selectSearch = function() {
		link_search.addClass('selected');
		link_shortlist.removeClass('selected');
	};
	INSTANCE.selectShortlist = function() {
		link_search.removeClass('selected');
		link_shortlist.addClass('selected');
	};
	INSTANCE.unselect = function() {
		link_search.removeClass('selected');
		link_shortlist.removeClass('selected');
	};
	INSTANCE.selectMenu = INSTANCE.unselect;
	
	
	// Update shortlist tally
	// 
	INSTANCE.updateShortlistTally = function( tally ) {
		tally_shortlist.text( tally );
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};